import React from 'react';
import styles from './index.module.scss';
import Layout, { IMAGES_PATH } from '../layout';
import FooterLinks from '../footer-links';

// Два варіанти екрана «опитувальник недоступний»: коли бекенд не впізнав
// профіль (feedback-51) і коли відгук цього місяця вже залишали.
// Відрізняються лише верхнім блоком, тому це один компонент із двома пресетами.
export const UNAVAILABLE_REASONS = {
  NOT_IDENTIFIED: 'NOT_IDENTIFIED',
  MONTHLY_LIMIT: 'MONTHLY_LIMIT'
};

const REASON_CONTENT = {
  [UNAVAILABLE_REASONS.NOT_IDENTIFIED]: {
    title: 'О ні!',
    subtitle: 'Твій профіль не було ідентифіковано ❌',
    subtitleWidth: 262
  },
  [UNAVAILABLE_REASONS.MONTHLY_LIMIT]: {
    title: 'Упс!',
    subtitle: 'Ти вже проходив(ла) опитувальник цього місяця ❌',
    subtitleWidth: 190
  }
};

const UnavailableScreen = ({
  reason = UNAVAILABLE_REASONS.NOT_IDENTIFIED,
  onTerms,
  onCookies
}) => {
  const { title, subtitle, subtitleWidth } =
    REASON_CONTENT[reason] ||
    REASON_CONTENT[UNAVAILABLE_REASONS.NOT_IDENTIFIED];

  return (
    <Layout contentClassName={styles.content}>
      <div className={styles.titleContainer}>
        <p className={styles.title}>{title}</p>
        <p className={styles.subtitle} style={{ maxWidth: subtitleWidth }}>
          {subtitle}
        </p>
      </div>
      <p className={styles.description}>
        Проходження опитувальника недоступне.
      </p>
      <img
        className={styles.image}
        src={`${IMAGES_PATH}/unavailable.svg`}
        alt="unavailable"
      />
      <FooterLinks
        className={styles.footerLinks}
        onTerms={onTerms}
        onCookies={onCookies}
      />
    </Layout>
  );
};

export default UnavailableScreen;
